import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';

import { BackButton } from 'components/header/navigation-bar/mobile-menu/fragments/back-button';
import { displaySettingsSelector } from 'common/selectors';
import { getI18nLng } from 'utils/i18n';

export const LanguageChangeMenu = connect((state) => ({
  displaySettings: displaySettingsSelector(state),
}))(({ showHideSubMenu, showHideMobileMenu, displaySettings: { languages } }) => {
  const { t } = useTranslation();
  if (languages.length === 1) {
    return false;
  }

  const i18nextLanguage = getI18nLng();

  return (
    <Fragment>
      <BackButton onClick={showHideSubMenu} />
      <ul className="ct-mobile-menu__list ct-mobile-menu__list--language-change-menu">
        {languages.map((language) => {
          return (
            <li
              key={language}
              className={`ct-mobile-menu__list-elem`}
            >
              <button
                className="ct-mobile-menu__button"
                data-e2e={`mobile-nav-item-${language}`}
                onClick={() => {
                  i18next.changeLanguage(language);
                  showHideMobileMenu();
                  showHideSubMenu();
                  window.scrollTo(0, 0);
                  document.location.reload();
                }}
              >
                {t(language)} {language === i18nextLanguage && <FontAwesomeIcon icon={faCheck} />}
              </button>
            </li>
          );
        })}
      </ul>
    </Fragment>
  );
});
